import { render, staticRenderFns } from "./CustomAddButton.vue?vue&type=template&id=6ca3805a&scoped=true"
import script from "./CustomAddButton.vue?vue&type=script&lang=js"
export * from "./CustomAddButton.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./CustomAddButton.vue?vue&type=style&index=0&id=6ca3805a&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "6ca3805a",
  null
  ,true
)

export default component.exports